module.exports = __webpack_public_path__ + "./image/020b924946905afd5ddfe3931e118122.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/app.jpg
// module id = 28
// module chunks = 1